import React, { Component } from "react";
//// componentes reutilizables
import TecladoPin from "../../../generico/TecladoPin";
import NumberFormat from "react-number-format";
import md5 from "md5";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import AuthService from "../../../../services/login/auth.service";
import TransferInterentidadService from "../../../../services/transferencias/TransferInterentidadService";
import resumenSocioService from "../../../../services/resumenGeneral/resumenSocioService";
import { MENSAJE } from "../../../generico/utils/Constantes";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

export default class TransferenciaInterentidad extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.tecladoPinRef = React.createRef();
  }

  getInitialState = () => ({
    pin: "",
    nroOperacion: 0,
    disableSgte: true,
  });

  resetState = () => {
    this.setState(this.getInitialState());
    this.tecladoPinRef.current.limpiarPin();
  };

  confirmarTransferencia = (titulo, mensaje, callback) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "No",
            className: "",
            action: function () {
              Popup.close();
            },
          },
          {
            text: "Sí",
            className: "success",
            action: function () {
              callback();
              Popup.close();
            },
          },
        ],
      },
    });

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  pinValue = (value) => {
    this.setState({
      pin: value,
    });
    this.enableNext(value);
  };
  enableNext(pin) {
    if (pin !== "" && pin.length === 6) {
      this.state.disableSgte = false;
    } else {
      this.state.disableSgte = true;
    }
  }

  confirmar = (e, transferenciaDatosRepetidos = false) => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");
    var importe = this.props.importe.split(".").join("");
    importe = String(importe).replace(/\,/g, ".");

    trackPromise(
      resumenSocioService.validarPin(
        this.state.pin
      ).then((response) =>{
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        
        if (jData.codigo === 0) {
          // PIN verificado exitosamente, proceder con la transferencia
          return TransferInterentidadService.confirmarTransferenciaInterbancaria(
            parseFloat(importe),
            this.props.cuentaOrigen.moneda,
            this.props.motivo,
            parseInt(this.props.cuentaOrigen.ahorro),
            "CI",
            AuthService.getSocio().nombreCompleto.trim(),
            this.props.cuentaDestino.codEntidad,
            this.props.cuentaDestino.nroCuenta,
            this.props.cuentaDestino.tipoDocDestino,
            this.props.cuentaDestino.docDestino,
            this.props.cuentaDestino.titular,
            md5(this.state.pin),
            this.props.cuentaDestino.destinatario,
            this.props.cuentaDestino.intermediario,
            this.props.cuentaDestino.alias,
            this.props.cuentaDestino.entidadDatosAlternativos,
            transferenciaDatosRepetidos
          );
        } else {
          // PIN verificación falló, mostrar mensaje de error
          this.btn.removeAttribute("disabled");
          this.tecladoPinRef.current.limpiarPin();
          return Promise.reject(new Error(jData.mensajeRespuesta));
        }
      }).then((response) => {
        //// Habilita boton
        this.btn.removeAttribute("disabled");
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        if (jData.codigo === 0) {
          var { nroOperacion, intermediario } = jData.datos;
          this.resetState();
          this.props.returnDataPaso4(nroOperacion, intermediario);
          this.props.nextStep();
        } else if (jData.codigo === 3) {
          Popup.queue(this.confirmarTransferencia("Atención", MENSAJE.CONFIRMAR_TRANSFERENCIA, (e) => this.confirmar(e, true)));
        } else {
          Popup.queue(this.notifiPopup("Info", jData.mensaje));
        }
      })
    ).catch((error) => {
      this.btn.removeAttribute("disabled");
      Popup.queue(this.notifiPopup(
        "Error",
        error?.message || "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste."
      ));
    });
  };
  render() {
    return (
      <div>
        <form id="idFormPaso4" onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="steps clearfix">
              <ul role="tablist">
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text current">
                        Selección de Cuentas
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Transferencia</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Código de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled last">
                  <span>
                    <div className="title">
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-8" style={{ marginBottom: 5 }}>
                  <h6 className="item-vef" style={{ margin: 0 }}>
                    Cuenta: {this.props.cuentaOrigen.ahorro} -{" "}
                    {AuthService.getSocio().nombreCompleto.trim()}
                  </h6>
                  <p className="item-vef" style={{ marginBottom: 0 }}>
                    Tipo: {this.props.cuentaOrigen.descripcion}
                  </p>
                  <p className="item-vef">Moneda: {this.props.cuentaOrigen.moneda}</p>
                </div>
              </div>
              <div className="row invoice-info">
                <div className="col-12">
                  <div className="table-responsive">
                    {this.props.cuen}
                    <table className="table">
                      <tbody>
                     
                      {(this.props.cuentaDestino.alias!==null) && ( 
                        <tr>
                          <th>Alias:</th>
                          <td>{this.props.cuentaDestino.alias}</td>
                        </tr>
                        )}
                        <tr>
                          <th>Cuenta Crédito:</th>
                          <td>{this.props.cuentaDestino.nroCuenta}</td>
                        </tr>
                       
                        <tr>
                          <th>Importe del Crédito:</th>
                          <td>
                            <NumberFormat
                              value={this.props.importe}
                              displayType={"text"}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                            />{" "}
                            {this.props.cuentaOrigen.moneda}.
                          </td>
                        </tr>
                        <tr>
                          <th>Titular de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.titular}</td>
                        </tr>
                        <tr>
                          <th>Tipo documento de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.tipoDocDestino}</td>
                        </tr>
                        <tr>
                          <th>Documento de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.docDestino}</td>
                        </tr>
                        <tr>
                          <th>Entidad:</th>
                          <td>{this.props.cuentaDestino.entidad}</td>
                        </tr>
                        <tr>
                          <th>Motivo:</th>
                          <td>{this.props.motivo}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
                <div className="invoice p-3 mb-3 teclados">
                  <TecladoPin
                    pinValue={this.pinValue.bind(this)}
                    label="Ingrese el Pin de Transacción"
                    ref={this.tecladoPinRef}
                  />
                </div>
            </div>
          </div>
          <hr />
          
            <div className="row">
            <div className="col-lg-8 col-md-6"></div>
            <div className="col-lg-2 col-md-3">
              <button
                className="btn btn-cu-quintary btn-consulta"
                onClick={ () => {this.props.goToStep(2)} }
              >
                <FontAwesomeIcon icon={faArrowLeft} />  Volver
              </button>
            </div>
            <div className="col-lg-2 col-md-3">
              <button
                ref={(btn) => { this.btn = btn; }}
                className="btn btn-cu-primary"
                disabled={this.state.disableSgte}
                onClick={this.confirmar}
              >
                Confirmar Transferencia <FontAwesomeIcon icon={faArrowRight} />
              </button>
           
            </div>
          </div>
        </form>
      </div>
    );
  }
}
